/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#street-view{position:absolute;left:0;top:0;height:100%;width:100%}#street-view-message{position:absolute;width:300px;z-index:9;left:50%;top:50%;margin-left:-150px}::slotted(.widget-group){position:absolute;display:-webkit-box;display:flex;-webkit-box-pack:end;justify-content:flex-end;top:0;right:60px;z-index:10}"];
export { styles as styles };
